import { UserLocationSuspend } from "../models/userLocationSuspendModel";
import { backendRequest } from "./backendApi";
import exceptionService from "./exceptionService";
const request = async <T = any>(path: string, body?: any) => {
  const r = await backendRequest<T>(path, body);
  if (r.error) exceptionService.logError(r.error, `locationSuspendService:${path}`);
  return r;
};
const locationSuspendService = {
  async fetchUserLocationSuspends(hostId: number) {
    return request("/location-suspensions/by-host", { hostId });
  },
  async insertUserLocationSuspend(item: UserLocationSuspend): Promise<Boolean> {
    return (await request<boolean>("/location-suspensions/insert", { item })).data === true;
  },
  async liftUserLocationSuspend(id: number): Promise<Boolean> {
    return (await request<boolean>("/location-suspensions/lift", { id })).data === true;
  },
  async updateLengthUserLocationSuspend(id: number, length: number): Promise<Boolean> {
    return (
      (await request<boolean>("/location-suspensions/update-length", { id, length })).data === true
    );
  },
  async checkIsUserLocationSuspended(hostId: number, userId: string): Promise<boolean> {
    return (
      (await request<boolean>("/location-suspensions/check", { hostId, userId })).data === true
    );
  },
  async fetchUserLocationSuspendsForUser(_userId: number) {
    return request("/location-suspensions/for-user");
  },
};
export default locationSuspendService;
